<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("transfer.条件筛选") }}
      </h6>
      <div>
        <div class="form-group mg-b-10">
          <input
            type="text"
            :placeholder="$t('transfer.国内快递单号')"
            class="form-control form-control-dark tx-13"
            v-model.trim="trackNumber"
          />
        </div>
        <div class="form-group mg-b-10">
          <input
            type="text"
            :placeholder="$t('transfer.内部ID')"
            class="form-control form-control-dark tx-13"
            v-model.trim="packageId"
          />
        </div>
        <div class="form-group mg-b-10">
          <div class="datepicker-group">
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="keyDateFrom"
                data-id="datepicker-from"
                type="text"
                class="form-control-dark form-control fc-datepicker"
                :placeholder="$t('transfer.起始日期')"
              />
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="keyDateTo"
                data-id="datepicker-to"
                type="text"
                class="form-control form-control-dark fc-datepicker"
                :placeholder="$t('transfer.截止日期')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate"
    >
      {{ $t("transfer.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "track_number", "time_from", "time_to", "package_id"],
  data() {
    return {
      keyDateFrom: "",
      keyDateTo: "",
      trackNumber: "",
      packageId: "",
    };
  },
  components: {},
  watch: {
    track_number() {
      this.trackNumber = this.track_number;
    },
    time_from() {
      this.keyDateFrom = this.time_from;
    },
    time_to() {
      this.keyDateTo = this.time_to;
    },
    package_id() {
      this.packageId = this.package_id;
    },
  },
  methods: {
    filtrate() {
      this.$emit(
        "filtrate",
        this.trackNumber,
        this.keyDateFrom,
        this.keyDateTo,
        this.packageId
      );
    },
    datepickerSelect() {
      let vm = this;
      $("[data-id=datepicker-from]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          maxDate: 0,
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.keyDateFrom = selectedDate;
          },
        });
      });
      $("[data-id=datepicker-to]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          maxDate: 0,
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.keyDateTo = selectedDate;
          },
        });
      });
    },
  },
  mounted() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  updated() {
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
};
</script>
